<template>
  <div class="FAQ bg-white">

    <!-- <Head></Head> -->
    <router-view />
    <!-- <Footer v-if="isPC"></Footer> -->
  </div>
</template>

<script>
// import Head from '../components/Head.vue'
// import Footer from '../components/Footer.vue'
export default {
  metaInfo: {
    title: 'Help Center - KakaClo',
    meta: [
      {
        name: 'description',
        content: 'KakaClo is the industry-leading apparel supply chain platform that focuses on providing customers with in stock apparel custom production and dropshipping service.'
      }
    ]
  }
  // components: { Footer, Head }
}
</script>
<style lang="scss" scoped>
.FAQ{
  font-family: 'Poppins', 'PingFang SC', 'Sen', 'Helvetica', 'Arial', 'Sans-serif';
}
</style>

